var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFacture = function SvgFacture(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C7FE1280-6C7C-45E2-A3A0-50948FF2EDEA") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.27272727,5 L9,5 L9,7 L3.27272727,7 L3.27272727,5 Z M16.3636364,0 L0,0 L0,14 L18,14 L18,0 L16.3636364,0 Z M16.3636364,12 L1.63636364,12 L1.63636364,3 L16.3636364,3 L16.3636364,12 Z M3.27272727,9 L14.7272727,9 L14.7272727,10 L3.27272727,10 L3.27272727,9 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SUEZ-PCE_UI_Lot1_Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "05_SUEZ-PCE_UI_client_05_accueil",
    transform: "translate(-86.000000, -339.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Latest-documents",
    transform: "translate(60.000000, 306.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Facture",
    transform: "translate(26.000000, 33.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Couleur/bleue-clair*",
    transform: "translate(3.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Color-/-Fill-/-Vert-Vivic",
    mask: "url(#mask-2)",
    fill: "#030F40"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.000000, 7.000000) rotate(-90.000000) translate(-9.000000, -7.000000) translate(-1.000000, -5.000000)",
    id: "Rectangle-5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 20,
    height: 24
  }))))))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFacture);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/facture.dc1b8902fd33cdfd29ce7492d4c7556d.svg";